module.exports = __webpack_public_path__ + "media/img/119131392_1777126519091866_1411076534981267829_n-6b090b09.jpg";